angular.module('ikeweb.spike.capture').value('BasicImageExport',
    function BasicImageExport(capture) {

        var self = this;
        var imageUrl = null;

        this.addImage = function(url) {
            imageUrl = url;
            return self;
        };

        this.addMeasurements = function() {
            return self;
        };

        this.getFilename = function() {
            return capture.getExportFilename() + '.jpg';
        };

        this.getURL = function() {
            return imageUrl;
        };

        this.getData = function() {
            return null;
        };
    });



//////////////////
// WEBPACK FOOTER
// ./src/client/components/spike/capture/basic.image.export.js
// module id = 516
// module chunks = 0